__turbopack_context__.v({
  "actions": "tools-module__simv5G__actions",
  "badge": "tools-module__simv5G__badge",
  "bar": "tools-module__simv5G__bar",
  "barHead": "tools-module__simv5G__barHead",
  "barRow": "tools-module__simv5G__barRow",
  "big": "tools-module__simv5G__big",
  "bridge": "tools-module__simv5G__bridge",
  "bridgeLink": "tools-module__simv5G__bridgeLink",
  "builder": "tools-module__simv5G__builder",
  "cardMeta": "tools-module__simv5G__cardMeta",
  "check": "tools-module__simv5G__check",
  "cite": "tools-module__simv5G__cite",
  "citeActions": "tools-module__simv5G__citeActions",
  "citeText": "tools-module__simv5G__citeText",
  "cmd": "tools-module__simv5G__cmd",
  "copyCompact": "tools-module__simv5G__copyCompact",
  "countdown": "tools-module__simv5G__countdown",
  "coverList": "tools-module__simv5G__coverList",
  "diagram": "tools-module__simv5G__diagram",
  "diagramImg": "tools-module__simv5G__diagramImg",
  "directoryBalanced": "tools-module__simv5G__directoryBalanced",
  "disclaimer": "tools-module__simv5G__disclaimer",
  "example": "tools-module__simv5G__example",
  "exampleInputs": "tools-module__simv5G__exampleInputs",
  "examples": "tools-module__simv5G__examples",
  "field": "tools-module__simv5G__field",
  "fieldset": "tools-module__simv5G__fieldset",
  "gauge": "tools-module__simv5G__gauge",
  "gaugeFill": "tools-module__simv5G__gaugeFill",
  "h3": "tools-module__simv5G__h3",
  "headWrap": "tools-module__simv5G__headWrap",
  "hint": "tools-module__simv5G__hint",
  "hintRow": "tools-module__simv5G__hintRow",
  "hivra": "tools-module__simv5G__hivra",
  "inlineCode": "tools-module__simv5G__inlineCode",
  "inlineNumber": "tools-module__simv5G__inlineNumber",
  "inlineRow": "tools-module__simv5G__inlineRow",
  "inputs": "tools-module__simv5G__inputs",
  "intro": "tools-module__simv5G__intro",
  "jumpNav": "tools-module__simv5G__jumpNav",
  "kbd": "tools-module__simv5G__kbd",
  "label": "tools-module__simv5G__label",
  "laterList": "tools-module__simv5G__laterList",
  "legend": "tools-module__simv5G__legend",
  "legend2": "tools-module__simv5G__legend2",
  "list": "tools-module__simv5G__list",
  "listDetail": "tools-module__simv5G__listDetail",
  "listName": "tools-module__simv5G__listName",
  "listPrice": "tools-module__simv5G__listPrice",
  "listRow": "tools-module__simv5G__listRow",
  "method": "tools-module__simv5G__method",
  "mode": "tools-module__simv5G__mode",
  "modeFix": "tools-module__simv5G__modeFix",
  "modeHead": "tools-module__simv5G__modeHead",
  "modeTitle": "tools-module__simv5G__modeTitle",
  "modes": "tools-module__simv5G__modes",
  "narrow": "tools-module__simv5G__narrow",
  "noLigatures": "tools-module__simv5G__noLigatures",
  "note": "tools-module__simv5G__note",
  "num": "tools-module__simv5G__num",
  "panel": "tools-module__simv5G__panel",
  "panelHead": "tools-module__simv5G__panelHead",
  "panelTitle": "tools-module__simv5G__panelTitle",
  "plainList": "tools-module__simv5G__plainList",
  "pre": "tools-module__simv5G__pre",
  "preWrap": "tools-module__simv5G__preWrap",
  "primaryButton": "tools-module__simv5G__primaryButton",
  "radio": "tools-module__simv5G__radio",
  "radios": "tools-module__simv5G__radios",
  "range": "tools-module__simv5G__range",
  "secondaryButton": "tools-module__simv5G__secondaryButton",
  "segAccent": "tools-module__simv5G__segAccent",
  "segFaint": "tools-module__simv5G__segFaint",
  "segInk": "tools-module__simv5G__segInk",
  "segLight": "tools-module__simv5G__segLight",
  "segMid": "tools-module__simv5G__segMid",
  "sheetDoes": "tools-module__simv5G__sheetDoes",
  "sheetIntro": "tools-module__simv5G__sheetIntro",
  "sheetKeys": "tools-module__simv5G__sheetKeys",
  "sheetRow": "tools-module__simv5G__sheetRow",
  "sheetRows": "tools-module__simv5G__sheetRows",
  "sheetSection": "tools-module__simv5G__sheetSection",
  "smallButton": "tools-module__simv5G__smallButton",
  "sources": "tools-module__simv5G__sources",
  "stat": "tools-module__simv5G__stat",
  "statLabel": "tools-module__simv5G__statLabel",
  "statValue": "tools-module__simv5G__statValue",
  "stats": "tools-module__simv5G__stats",
  "swatch": "tools-module__simv5G__swatch",
  "table": "tools-module__simv5G__table",
  "tableWrap": "tools-module__simv5G__tableWrap",
  "toneBad": "tools-module__simv5G__toneBad",
  "toneGood": "tools-module__simv5G__toneGood",
  "toneWarn": "tools-module__simv5G__toneWarn",
  "tool": "tools-module__simv5G__tool",
  "toolSection": "tools-module__simv5G__toolSection",
  "total": "tools-module__simv5G__total",
  "verdict": "tools-module__simv5G__verdict",
  "verdictBox": "tools-module__simv5G__verdictBox",
  "verdictDetail": "tools-module__simv5G__verdictDetail",
  "verdictTitle": "tools-module__simv5G__verdictTitle",
  "verified": "tools-module__simv5G__verified",
  "word": "tools-module__simv5G__word",
});
